import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { useStudent } from '../../context/StudentContext';

const Card = styled(Link)`
  border-radius: 8px;
  text-decoration: none;
  color: inherit;
  transition: transform 0.2s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 0 0 1.5rem 0;
  &:hover {
    transform: translateY(-4px);
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 180px;
  border-radius: 6px;
  overflow: hidden;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CourseImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Title = styled.h3`
  font-family: 'Raleway', sans-serif;
  padding: 1.5rem 1.5rem 0 1.5rem;
  margin: 0;
`;

const Description = styled.p`
  font-size: 0.9rem;
  padding: 0 1.5rem;
`;

const MetaInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.8rem;
  padding: 0 1.5rem;
`;

const ProgressBar = styled.div`
  height: 4px;
  border-radius: 2px;
  margin-top: 1rem;
  padding: 0 1.5rem;
`;

const Progress = styled.div`
  height: 100%;
  width: ${({ progress }) => `${progress}%`};
  background-color: ${({ progress }) => (progress > 0 ? '#007bff' : '#ccc')};
  border-radius: 2px;
`;

const CourseCard = ({ course }) => {
  const { student } = useStudent();

  const courseProgress = student?.courseProgress?.[course.id];
  const progress = Math.round(
    ((courseProgress?.completedLessons?.length || 0) / course?.AcademyLessons?.length) * 100
  );

  return (
    <Card to={`/crecerplus/${course.id}`}>
      {course.image ? (
        <ImageContainer>
          <CourseImage src={course.image} alt={course.title} />
        </ImageContainer>
      ) : null}
      <Title>{course.title}</Title>
      <Description>{course.description}</Description>
      <MetaInfo>
        <span>{progress > 100 ? 100 : progress} %</span>
      </MetaInfo>
      {!!progress && (
        <ProgressBar>
          <Progress progress={progress > 100 ? 100 : progress} />
        </ProgressBar>
      )}
    </Card>
  );
};

export { CourseCard };
